import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DownArrowDraw,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { useNavigate } from "react-router";
import {
  Button,
  Row,
  Col,
  Form,
  Select,
  Input,
  PageHeader,
  Radio,
  Checkbox,
  Collapse,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation } from "react-router-dom";
import {
  inviteNewUser,
  deleteUserAccount,
} from "../../../Services/loginServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import warning from "../../../Assets/Icons/warning.png";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { getAllRoles } from "../../../Services/notifications&rolesServices";
const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const notificationData = [
    {
      id: 1,
      name: "Orders",
      text: "User access to order management can be controlled here",
      options: [
        {
          name: "Requests",
          options: ["Order Approval Request"],
        },
        {
          name: "Confirmations",
          options: [
            "Order Approval Confirmation",
            "Order Rejection Alert",
            "Priority Flag Notification",
          ],
        },
      ],
    },
    {
      id: 2,
      name: "Job Cards",
      text: "User access to job card management can be controlled here",
      options: [
        {
          name: "Requests",
          options: ["Job Card Approval Request"],
        },
        {
          name: "Confirmations",
          options: [
            "Job Card Approval Confirmation",
            "Job Card Completion Confirmation",
            "Job Card Resubmitted for Approval",
          ],
        },
        {
          name: "Rejections",
          options: ["Job Card Rejection Alert", "Job Card Cancellation Alert"],
        },
      ],
    },
    // {
    //   id: 3,
    //   name: "Warehouse",
    //   text: "User access to warehouse operations can be controlled here",
    //   options: [
    //     {
    //       name: "Alerts",
    //       options: [
    //         "Stock Allocation Failure",
    //         "Stock Threshold Alert",
    //         "Location Capacity Breach",
    //       ],
    //     },
    //     {
    //       name: "Confirmations",
    //       options: ["Stock Movement Confirmation"],
    //     },
    //     {
    //       name: "Requests",
    //       options: ["Addition/Deletion of Warehouse Location"],
    //     },
    //   ],
    // },
    {
      id: 4,
      name: "System",
      text: "System-level notifications can be controlled here",
      options: [
        {
          name: "Alerts",
          options: [
            "Error during Save/Submission",
            "Failure of Fetch Orders",
            "Machine Inactive",
          ],
        },
        {
          name: "Confirmations",
          options: ["Bulk Upload of Orders Confirmation"],
        },
      ],
    },
  ];

const { Option } = Select;

const validateMessages = {
  required: "This field is required!",
  types: {
    email: "Not a valid email format!",
  },
};

const InviteUserData = (props) => {
  const [alert, setAlert] = useState(false);
  const [warningMsg, setWarningMsg] = useState();
  const [message, setMessage] = useState();
  const [userTypeData,setUserTypeData] = useState([]);
  const [collapseActiveKeys, setCollapseActiveKeys] = useState({});
  //   const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const showAlert=()=>{
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  }
  const handleUserChange = (value) => {
    let fieldsValue= {};
    
    switch(value){
      case "ADMIN":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: true,
          job_card_cancellation_alert_in_app: true,
          job_card_rejection_alert_email: true,
          job_card_rejection_alert_in_app: true,
          job_card_approval_request_email: true,
          job_card_approval_request_in_app: true,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: true,
          priority_flag_notification_in_app: true,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          "error_during_save/submission_email": true,
          "error_during_save/submission_in_app": true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: true,
          bulk_upload_of_orders_confirmation_in_app: true,
        };
        break;
      case "SALES COORDINATOR":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: false,
          job_card_cancellation_alert_in_app: false,
          job_card_rejection_alert_email: false,
          job_card_rejection_alert_in_app: false,
          job_card_approval_request_email: true,
          job_card_approval_request_in_app: true,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: false,
          priority_flag_notification_in_app: false,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          ["error_during_save/submission_email"]: true,
          ["error_during_save/submission_in_app"]: true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: false,
          bulk_upload_of_orders_confirmation_in_app: false,
        };
        break;
      case "PLANT OPERATOR":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: true,
          job_card_cancellation_alert_in_app: true,
          job_card_rejection_alert_email: true,
          job_card_rejection_alert_in_app: true,
          job_card_approval_request_email: false,
          job_card_approval_request_in_app: false,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: true,
          priority_flag_notification_in_app: true,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          ["error_during_save/submission_email"]: true,
          ["error_during_save/submission_in_app"]: true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: false,
          bulk_upload_of_orders_confirmation_in_app: false,
        };
        break;
      case "DECKLE PLANNER":
        fieldsValue = {
          job_card_approval_confirmation_email: true,
          job_card_approval_confirmation_in_app: true,
          job_card_completion_confirmation_email: true,
          job_card_completion_confirmation_in_app: true,
          job_card_resubmitted_for_approval_email: true,
          job_card_resubmitted_for_approval_in_app: true,
          job_card_cancellation_alert_email: false,
          job_card_cancellation_alert_in_app: false,
          job_card_rejection_alert_email: false,
          job_card_rejection_alert_in_app: false,
          job_card_approval_request_email: true,
          job_card_approval_request_in_app: true,
          order_approval_confirmation_email: false,
          order_approval_confirmation_in_app: false,
          order_rejection_alert_email: false,
          order_rejection_alert_in_app: false,
          priority_flag_notification_email: true,
          priority_flag_notification_in_app: true,
          order_approval_request_email: false,
          order_approval_request_in_app: false,
          ["error_during_save/submission_email"]: true,
          ["error_during_save/submission_in_app"]: true,
          failure_of_fetch_orders_email: true,
          failure_of_fetch_orders_in_app: true,
          machine_inactive_email: true,
          machine_inactive_in_app: true,
          bulk_upload_of_orders_confirmation_email: false,
          bulk_upload_of_orders_confirmation_in_app: false,
        };
        break;
    }
    form.setFieldsValue(fieldsValue);
  };

  const onFinish = async (values) => {
   

    try {
       console.log(values);
       form.validateFields();
    const body = {
      email: values.email,
      role_type: values.role_type,
      notification_config: {
        jobcard:{
          confirmations:{
            jobcard_approval: {
              email: values?.job_card_approval_confirmation_email,
              in_app: values?.job_card_approval_confirmation_in_app
            },
            jobcard_completion: {
              email: values?.job_card_completion_confirmation_email,
              in_app: values?.job_card_completion_confirmation_in_app
            },
            jobcard_resubmitted: {
              email: values?.job_card_resubmitted_for_approval_email,
              in_app: values?.job_card_resubmitted_for_approval_in_app
            }
          },
          rejections:{
            jobcard_cancellation_alert:{
              email: values?.job_card_cancellation_alert_email,
              in_app: values?.job_card_cancellation_alert_in_app
            },
            jobcard_rejection_alert:{
              email: values?.job_card_rejection_alert_email,
              in_app: values?.job_card_rejection_alert_in_app
            }
          },
          requests:{
            jobcard_approval:{
              email: values?.job_card_approval_request_email,
              in_app: values?.job_card_approval_request_in_app
            }
          }
        },
        orders:{
          confimations:{
            order_approval:{
              email: values?.order_approval_confirmation_email,
              in_app: values?.order_approval_confirmation_in_app
            },
            order_rejection_alert:{
              email: values?.order_rejection_alert_email,
              in_app: values?.order_rejection_alert_in_app
            },
            priority_flag_notification:{
              email: values?.priority_flag_notification_email,
              in_app: values?.priority_flag_notification_in_app
            }
          },
          requests:{
            order_approval:{
              email: values?.order_approval_request_email,
              in_app: values?.order_approval_request_in_app
            }
          }    
        },
        system:{
          alerts:{
            error_during_save:{
              email: values['error_during_save/submission_email'],
              in_app: values['error_during_save/submission_in_app']
            },
            fetch_orders_failure:{
              email: values?.failure_of_fetch_orders_email,
              in_app: values?.failure_of_fetch_orders_in_app
            },
            inactive_machine:{
              email: values?.machine_inactive_email,
              in_app: values?.machine_inactive_in_app
            }
          },
          confirmations:{
            bulk_action:{
              email: values?.bulk_upload_of_orders_confirmation_email,
              in_app: values?.bulk_upload_of_orders_confirmation_in_app
            }
          }
        }
      }
    };
      const inviteNewUserResponse = await inviteNewUser(body);
      showAlert();
      setWarningMsg(false);
      setMessage(inviteNewUserResponse.data.msg);
      setTimeout(() => {
        navigate("/organization-setting/user-management");
      }, 2500);
    } catch (error) {
      showAlert()
      setWarningMsg(true);
      setMessage(error.response.data.msg);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const showCancelModal = () => {
    setVisible(true);
  };

  const closeCancelModal = () => {
    setVisible(false);
  };

  const confirmCancelModal = () => {
    form.resetFields();
    setVisible(false);
    navigate("../user-management");
  };

  const handleCollapseChange = (notifId, key) => {
    const keys = Array.isArray(key) ? key.map(String) : key == null ? [] : [String(key)];
    setCollapseActiveKeys((prev) => ({ ...prev, [notifId]: keys }));
  };

  const cancelChangeHandler = () => {
    showCancelModal();
  };

  useEffect(()=>{
    const fetchRoles = async () => {
      try{
        const roles=await getAllRoles();
        setUserTypeData(roles.map(role=>role.name.replaceAll("_"," ")));
      }
      catch(e)
      {
        console.log(e);
      }
    };
    fetchRoles();
  },[])
  return (
    <Form
      name="basic"
      autoComplete="off"
      className="haberLogin"
      initialValues={{
        remember: true,
      }}
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      {alert ? (
        <AlertContainer
          color={warningMsg ? "red" : "green"}
          icon={warningMsg ? alertRed : alertGreen}
          msg={message}
        />
      ) : (
        ""
      )}

      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Invite User"
            extra={[
              <Button
                key="3"
                type="button"
                onClick={() => cancelChangeHandler()}
                className="textTypeBtn"
              >
                Cancel changes
              </Button>,
              <Button
                key="1"
                className="themeBtn"
                type="primary"
                htmlType="submit"
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Invite User
              </Button>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        <DetailFields>
          <HaberForm>
            <div className="groupDetailWrap">
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>Enter general details of the user</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Email Address</label>
                        <p>User can login using this email address</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              type: "email",
                              message:
                                "The email address you entered is either invalid or not a verified email",
                            },
                          ]}
                          className=""
                        >
                          <Input placeholder="Enter Email" />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Role Type</label>
                        <p>User will have selected role</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="role_type"
                          // initialValue={userTypeData[1]}
                          required={true}
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <Select
                            suffixIcon={<DownArrowDraw />}
                            onChange={handleUserChange}
                          >
                            {userTypeData.map((userType) => (
                              <Option key={userType}>{userType}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="groupForm"
                style={{ borderBottom: "0px" }}
              >
                <Col span={8}>
                  <GroupTitle style={{ marginTop: "10px" }}>
                    <h2>Notifications</h2>
                    <p>This user will have access to selected notifications</p>
                  </GroupTitle>
                </Col>
              </Row>
              {notificationData.map((notification) => (
                <Row gutter={[16, 16]} className="groupForm">
                  <Col span={8}>
                    <GroupTitle>
                      <h2>{notification.name}</h2>
                      <p>{notification.text}</p>
                    </GroupTitle>
                  </Col>
                  <Col span={16}>
                    <Row
                      className="centerAlign titleVCenter paddingTB"
                      style={{ border: "none" }}
                    >
                      <Col span={24}>
                        <Collapse
                          // onChange={onChangeCollpase}
                          expandIconPosition="right"
                          bordered={false}
                          style={{
                            backgroundColor: "white",
                            width: "100%",
                            border: "none",
                          }}
                          activeKey={
                            collapseActiveKeys[notification.id] ??
                            notification.options.map((_, index) => String(index))
                          }
                          onChange={(key) => handleCollapseChange(notification.id, key)}
                        >
                          {notification.options.map((group, groupIndex) => (
                            <CollapsePanel
                              key={String(groupIndex)}
                              style={{ width: "100%", border: "none" }}
                              header={
                                <div
                                  className="boxFieldTitle"
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <label>{group.name}</label>
                                </div>
                              }
                              extra={
                                <Button
                                  className={"textTypeBtn"}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    group.options.forEach((opt)=>{
                                      form.setFieldsValue({
                                        [`${opt}_in_app`.toLowerCase().replaceAll(" ", "_")]:false,
                                        [`${opt}_email`.toLowerCase().replaceAll(" ", "_")]:false
                                      })
                                    })
                                    setCollapseActiveKeys((prev) => {
                                      const current = prev[notification.id] ?? notification.options.map((_, i) => String(i));
                                      const newKeys = (Array.isArray(current) ? current : [current]).filter(k => k !== String(groupIndex));
                                      return { ...prev, [notification.id]: newKeys };
                                    });
                                  }}
                                >
                                  Disable all
                                </Button>
                              }
                              forceRender={true}
                            >
                              <Row span={24}>
                                <Col span={12}></Col>
                                <Col span={12}>
                                  <Row span={24}>
                                    <Col span={12}>
                                      <div
                                        className="boxFormType"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <span>In App</span>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        className="boxFormType"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <span>Email</span>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              {group.options.map((opt, optIndex) => (
                                <Row span={24} key={optIndex}>
                                  <Col span={12}>
                                    <div className="boxFieldTitle">
                                      <span>{opt}</span>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <Row span={24}>
                                      <Col span={12}>
                                        <div className="boxFormType reverseCheckbox">
                                          <Form.Item
                                            name={`${opt}_in_app`
                                              .toLowerCase()
                                              .replaceAll(" ", "_")}
                                            valuePropName={"checked"}
                                          >
                                            <Checkbox
                                              onChange={(e) => {
                                                form.setFieldsValue({
                                                  [`${opt}_in_app`
                                                    .toLowerCase()
                                                    .replaceAll(" ", "_")]:
                                                    e.target.checked,
                                                });
                                              }}
                                              className="flexRowReverse"
                                            />
                                          </Form.Item>
                                        </div>
                                      </Col>
                                      <Col span={12}>
                                        <div className="boxFormType reverseCheckbox">
                                          <Form.Item
                                            name={`${opt}_email`
                                              .toLowerCase()
                                              .replaceAll(" ", "_")}
                                            valuePropName="checked"
                                          >
                                            <Checkbox
                                              onChange={(e) => {
                                                form.setFieldsValue({
                                                  [`${opt}_email`
                                                    .toLowerCase()
                                                    .replaceAll(" ", "_")]:
                                                    e.target.checked,
                                                });
                                              }}
                                              className="flexRowReverse"
                                            />
                                          </Form.Item>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              ))}
                            </CollapsePanel>
                          ))}
                        </Collapse>
                      </Col>
                    </Row>
                    {/* <Row className="centerAlign titleVCenter paddingTB">
                      <Col span={24}>
                        <Collapse
                          // onChange={onChangeCollpase}
                          expandIconPosition="right"
                          bordered={false}
                          style={{ backgroundColor: "white", width: "100%" }}
                        ></Collapse>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>
              ))}
            </div>
          </HaberForm>
        </DetailFields>

        <ConfirmationModal
          visible={visible}
          icon={warning}
          confirmAction={confirmCancelModal}
          cancelAction={closeCancelModal}
        >
          <span>Are you sure?</span>
          <p>
            You have pending changes on this page, are you sure you want to
            leave?
          </p>
        </ConfirmationModal>
      </RightLayoutContainer>
    </Form>
  );
};

export default InviteUserData;
